import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}
const selectIsStillMarried = async () => {
  const formStore = useFormStore()
  formStore.draft.request = {
    ...formStore.draft.request,
    isApplicantMarriedStatus: formStore.form.values.isStillMarried ? 1 : 0
  }
}
const selectIsFatherWorking = async () => {
  const formStore = useFormStore()
  formStore.draft.request = {
    ...formStore.draft.request,
    isApplicantWorkStatusFlag: formStore.form.values.isFatherWorking ? 1 : 0
  }
}
const usersInfoByIdnOrUnifiedNumberOnly = async ({ isUnifiedNumber } = actionParams) => {
  const formStore = useFormStore()
  const { motherUnifiedNumber, motherIdentityNumber } = formStore.form.values || {}
  const serviceTransactionId = router.currentRoute.value.params.serviceId

  if (motherUnifiedNumber || (motherIdentityNumber && motherIdentityNumber.length >= 15)) {
    try {
      let IdentityNumberOrUnifiedNumber = isUnifiedNumber
        ? motherUnifiedNumber
        : motherIdentityNumber
      const params = {
        isUnifiedNumber,
        IdentityNumberOrUnifiedNumber,
        ServiceTransId: serviceTransactionId
      }

      const res = await apiHelperService.get(`/api/individual/usersInfoByIdnOrUnifiedNumberOnly`, {
        params
      })
      const { unifiedNumber, identityCardNumber } = res
      formStore.form.setValues({
        motherUnifiedNumber: unifiedNumber,
        motherIdentityNumber: identityCardNumber
      })
    } catch (error) {
      console.error('usersInfoByIdnOrUnifiedNumberOnly', error)
      doNotify(
        i18n.global.t('personNumberIsWrongOrNotRelated'),
        i18n.global.t('personNumberIsWrongOrNotRelated')
      )

      formStore.form.setValues({
        motherUnifiedNumber: '',
        motherIdentityNumber: ''
      })
    }
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'usersInfoByIdnOrUnifiedNumberOnly':
      usersInfoByIdnOrUnifiedNumberOnly(actionParams)
      break
    case 'selectIsStillMarried':
      selectIsStillMarried(actionParams)
    case 'selectIsFatherWorking':
      selectIsFatherWorking(actionParams)
      break
    default:
      break
  }
}
